<template>
  <div>

    <b-dropdown left
                variant="link"
                no-caret
                ref="dropDown"
                class="desktop-camera-capture">
      <b-dropdown-item
          @click="browseComputer">
        {{ $t('browse_computer') }}
      </b-dropdown-item>
      <b-dropdown-item
          @click="openDesktopCamera">
        {{ $t('take_photo') }}
      </b-dropdown-item>
    </b-dropdown>

    <b-modal v-model="showCamera"
             hide-header
             size="md"
             @shown="captureShown"
             hide-footer>
      <div class="pt-3">
        <video class="video-capture" ref="video" autoplay></video>

        <div class="row mt-3">
          <div class="col-md-6">
            <button class="btn btn-themed btn-themed-outline btn-themed-squared w-100"
                    @click="showCamera = false">{{ $t('cancel') }}</button>
          </div>
          <div class="col-md-6">
            <button class="btn btn-themed btn-themed-squared w-100"
                    @click="capturePhoto">{{ $t('take_photo') }}</button>
          </div>

        </div>

        <canvas ref="canvas" style="display:none;"></canvas>
      </div>
    </b-modal>

  </div>

</template>

<script setup>
import { ref } from "vue"

const showCamera = ref(false)
const video = ref(null)
const canvas = ref(null)
const dropDown = ref()
let stream = null

const emit = defineEmits(['captured', 'browse'])

const openDesktopCamera = async () => {
  showCamera.value = true
}

const captureShown = async () => {
  stream = await navigator.mediaDevices.getUserMedia({
    video: true
  })
  video.value.srcObject = stream
}

const capturePhoto = () => {
  const context = canvas.value.getContext('2d')
  canvas.value.width = video.value.videoWidth
  canvas.value.height = video.value.videoHeight
  context.drawImage(video.value, 0, 0)

  canvas.value.toBlob((blob) => {
    if (blob) {
      const file = new File([blob], 'photo.png', { type: 'image/png' })
      emit('captured', file)
      stream.getTracks().forEach(track => track.stop())
      showCamera.value = false
    }
  }, 'image/png', 0.95)
}

const browseComputer = () => {
  emit('browse')
}

const launchDropdown = () => {
  dropDown.value?.show()
}

defineExpose({
  launchDropdown
})
</script>

<style scoped lang="scss">
.desktop-camera-capture {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  border-radius: 100%;
  left: 0;
  top: 0;
  cursor: pointer;
}
.video-capture {
  width: 100%;
  border-radius: 16px;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}
@media screen and (max-width: 768px) {
  .desktop-camera-capture {
    display: none;
  }
}
</style>
